<template>
  <div>
    <container-headline
      :headline="$t('global.generalapplicationinformation')"
      :col="6"
    ></container-headline>
    <div class="row mb-3">
      <div class="col-xl-12 block br-t-l-0">
        <div class="eingabe-panel-kopf p-3">
          <div class="row">
            <div class="col-xl-6 form-group">
              <v-select
                v-model="einsatz.hofangaben.einsatzherkunftJugendliche"
                :options="einsatzherkunftJugendliche"
                :disabled="!editable"
                multiple
                :placeholder="$t('global.regionsyouths')"
                label="bezeichnung"
              >
                <span slot="no-options">{{ $t("global.taptosearch") }}</span>
              </v-select>
              <label>{{ $t("global.regionsyouths") }}</label>
            </div>
            <div class="col-xl-6 form-group">
              <v-select
                v-model="einsatz.hofangaben.auswahlEinsatzbereich"
                :options="auswahlEinsatzbereich"
                :disabled="!editable"
                multiple
                :placeholder="$t('global.areasofapplication')"
                label="bezeichnung"
              >
                <span slot="no-options">{{ $t("global.taptosearch") }}</span>
              </v-select>
              <label>{{ $t("global.areasofapplication") }}</label>
            </div>
          </div>
          <div class="row">
            <div class="form-check col-xl-6" style="padding-left: 36px">
              <input
                type="checkbox"
                v-model="einsatz.hofangaben.eigenesZimmer"
                class="form-check-input"
                :disabled="!editable"
              />
              <label>{{ $t("global.ownroomavailable") }}</label>
            </div>
            <div class="col-xl-6">
              <div class="form-group">
                <input
                  v-model.trim="einsatz.hofangaben.zimmerteilungDetails"
                  class="form-control"
                  placeholder=" "
                  :readonly="!editable"
                />
                <label>{{ $t("global.roomsharingdetails") }}</label>
              </div>
            </div>
          </div>
          <div class="row">
<!--             <div class="col-xl-6">
              <div class="form-group">
                <input
                  v-model.trim="einsatz.hofangaben.wohnsituation"
                  class="form-control"
                  placeholder=" "
                  :readonly="!editable"
                />
                <label>{{ $t("global.livingconditions") }}</label>
              </div>
            </div> -->
            <div class="col-xl-6">
              <div class="form-group">
                <input
                  v-model.trim="einsatz.hofangaben.abholstation"
                  class="form-control"
                  placeholder=" "
                  :readonly="!editable"
                />
                <label>{{ $t("global.pickupstation") }}</label>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import ContainerHeadline from "@/components/ContainerHeadline";

import store from "@/store";
import { LADE_AUSWAHLWERTE_AGRIVIVA_FIRMA } from "@/store/agriviva-firma/actions.type";

export default {
  name: "FirmaAllgemeineEinsatzangabenNewViva",
  components: {
    ContainerHeadline,
  },
  mixins: [],
  store,
  props: {
    einsatz: {
      type: Object,
      required: true,
    },
    editable: {
      type: Boolean,
      required: true,
    },
  },
  data() {
    return {
      // Define any local data properties here if needed
    };
  },
  computed: {
    einsatzherkunftJugendliche() {
      if (this.$store)
        return this.$store.state.agrivivaFirma.einsatzherkunftJugendliche;
      return [];
    },
    auswahlEinsatzbereich() {
      if (this.$store)
        return this.$store.state.agrivivaFirma.auswahlEinsatzbereich;
      return [];
    },
  },
  watch: {},
  created() {},
  methods: {},
  mounted() {
    if (this.einsatzherkunftJugendliche?.length == 0)
      this.$store.dispatch(`agrivivaFirma/${LADE_AUSWAHLWERTE_AGRIVIVA_FIRMA}`);
  },
};
</script>
